import styled from 'styled-components/macro';
import { ReactComponent as CheckIcon } from 'static/ic-collected-check.svg';
import { mediaDesktop } from 'breakpoints';

export const CollectionTag = styled.div<{ background?: string, color?: string; }>`
  display: inline-block;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  background: ${({ background }) => (background || 'linear-gradient(80deg, #e9e9e9 0%, #ffffff 103%)')};
  color: ${({ color }) => (color || '#000')};

  ${mediaDesktop} {
    font-size: 18px;
  }
`;

export const CheckIconSVG = styled(CheckIcon)`
  g {
    stroke: ${({ color }) => (color ? `${color}` : '#000')};
  }
  width: 12px;
  height: 12px;
  margin-right: 5px;

  ${mediaDesktop} {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px 0 5px;

  ${mediaDesktop} {
    padding: 0 12px 0 6px;
  }
`;
